import React, { useState } from "react";
import { Link } from "@reach/router";
import styles from "./MammalChampion.module.scss";
import JoinComponent from "./JoinComponent";
import Username from "./Username";

function MammalChampion(props) {
  const [mammalNo, setMammalNo] = React.useState(0);

  let answerNo = mammalNo * 2;
  const mammalAnswers = [
    "Yes",
    "No",
    "Yes",
    "No",
    "Yes",
    "No",
    "Very",
    "Not at all",
    "Not at all",
    "Kind of",
    "I can't wait",
    "I'm okay",
    "Very good",
    "I'm not good",
    "I can't wait",
    "I'm okay",
  ];

  if (mammalNo === 0) {
    return (
      <div className={styles.bkg}>
        <p>"Welcome newcomer to the gate to the Mammal Folk's lair.</p>
        <p> I am the Folk's Champion, the Fox.</p>
        <p>
          I am looking for someone to learn from me, so they can become the next
          Champion when I retire!
        </p>
        <p>
          If you answer these questions like a Fox, you may be accepted into the
          Mammal Folk. Ready to go?"
        </p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(1);
          }}
        >
          Yes
        </button>
        &nbsp;
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(7);
          }}
        >
          No
        </button>
        <br />
        <JoinComponent folk={props.type} alpha={props.alpha} />
      </div>
    );
  }
  if (mammalNo === 1) {
    return (
      <div className={styles.bkg}>
        <p>Right first question, do you have good hearing ?</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(2);
          }}
        >
          Yes
        </button>
        &nbsp;
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(3);
          }}
        >
          No
        </button>
      </div>
    );
  }
  if (mammalNo === 2) {
    return (
      <div className={styles.bkg}>
        <p>
          "Well isn't that amazing, you would fit right in here as us foxes can
          hear a clock tick up to 40 meters away. Also you will need to listen
          to our fellow Mammal's stories of Liverpool to help us write the
          Incident Markers...
        </p>
        <p>hmmmmm what about this are you cunning?"</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(4);
          }}
        >
          Yes
        </button>
        &nbsp;
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(8);
          }}
        >
          No
        </button>
      </div>
    );
  }
  if (mammalNo === 3) {
    return (
      <div className={styles.bkg}>
        <p>Are you very fussy at eating?</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(5);
          }}
        >
          Not at all{" "}
        </button>
        &nbsp;
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(9);
          }}
        >
          Kind of{" "}
        </button>
      </div>
    );
  }
  if (mammalNo === 4) {
    return (
      <div className={styles.bkg}>
        <p>
          "So you can trick your enemies with your cunning before you battle
          them, I like that! It will prove a very useful trait to win this
          Tournament!
        </p>
        <p>Now comes the last question</p>
        <p>Do you swear allegiance to the Mammal Folk?"</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(10);
          }}
        >
          I can't wait!
        </button>
        &nbsp;
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(11);
          }}
        >
          I'm okay
        </button>
      </div>
    );
  }
  if (mammalNo === 5) {
    return (
      <div className={styles.bkg}>
        <p>"You are on track of being in our pack...</p>
        <p>Are you any good at navigating around places?</p>
        <p>Are you good with maps?"</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(6);
          }}
        >
          very good
        </button>
        &nbsp;
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(12);
          }}
        >
          I'm not good
        </button>
      </div>
    );
  }
  if (mammalNo === 6) {
    return (
      <div className={styles.bkg}>
        <p>
          "Well get ready, as you can now join us...the clever cunning Mammals!"
        </p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(10);
          }}
        >
          I can't wait
        </button>
        &nbsp;
        <button
          className={styles.choice}
          onClick={(event) => {
            setMammalNo(11);
          }}
        >
          I'm okay
        </button>
      </div>
    );
  }
  if (mammalNo === 7) {
    return (
      <div className={styles.bkg}>
        <p>"You seem to be more of a Bird Folk than a Mammal Folk kind..."</p>
      </div>
    );
  }
  if (mammalNo === 8) {
    return (
      <div className={styles.bkg}>
        <p>"Hmmm.... actually I can see you as a Plant Folk!</p>

        <p>Boring, lonely... See you at the end of the Tournament loser!"</p>
      </div>
    );
  }
  if (mammalNo === 9) {
    return (
      <div className={styles.bkg}>
        <p>"Hmmm.... actually I can see you as a Plant Folk!</p>

        <p>Boring, lonely... See you at the end of the Tournament loser!"</p>
      </div>
    );
  }
  if (mammalNo === 10) {
    return (
      <div className={styles.bkg}>
        <p>
          Great news, so brush that fur and swooosh that tail and let's get you
          started!!
        </p>

        <Link className={styles.choice} to={"/" + props.type + ""}>
          Enter as one of the Mammal Folk
        </Link>
      </div>
    );
  }
  if (mammalNo === 11) {
    return (
      <div className={styles.bkg}>
        <p>"Okay, get going, see if you can find the Insect Folk!!</p>
        <p>They are insignificant little nothing!! Good luck with that!!</p>
        <p>Bye loseeeeer!! The Tournament is ours!!"</p>
      </div>
    );
  }
  if (mammalNo === 12) {
    return (
      <div className={styles.bkg}>
        <p>
          {" "}
          "hmmmmmmmmmmmmm you're actually more a Natural Feature Folk type.
          Something big, dirty and slow like the River Mersey.
        </p>

        <p>See you when we win! You loser!"</p>
      </div>
    );
  }
}

export default MammalChampion;
